<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container style="margin-bottom: 50px;background: #fff">
      <a-form :form="form" slot="detail">
        <a-row class="form-box">
          <a-col :span="24">
            <j-upload-dragger bizPath="driverFile_download" ref="upd" @change="changeFileUrl" v-decorator="['fileUrl', validatorRules.fileUrl]"></j-upload-dragger>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件名称">
              <a-input  v-decorator="['fileName', validatorRules.fileName]" placeholder="请输入附件名称"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea     v-decorator="['remark', validatorRules.remark]" rows="4" placeholder="请输入备注" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import Vue from 'vue'
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import ACol from "ant-design-vue/es/grid/Col";
  export default {
    name: 'DriverFileForm',
    components: {
      ACol
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          fileUrl:{
            rules: [
              { required: true, message: '请上传附件!'},
            ]
          },
          fileName:{
            rules: [
              { required: true, message: '请输入附件名称!'},
            ]
          }
        },
        url: {
          add: "/dm/dmDriverFile/add",
          edit: "/dm/dmDriverFile/edit"
        }
      }
    },
    computed: {

    },
    created () {

    },
    methods: {
       add (record) {

        this.edit(record);

      },
      edit (record) {
        this.model = {};
        this.form.resetFields();
        this.model = Object.assign({}, record);
        if(record.fileUrl){
          this.$refs.upd.init(2);
        }else{
          this.$refs.upd.init();
        }
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'coverImg','driverId','fileUrl','fileName','fileType','remark'))
        })
      },
      submitForm () {

        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {

            if(!values.fileUrl && !this.model.fileUrl){
              this.$message.warning("请上传附件!");
              return;
            }
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl=this.url.add;
              method = 'post';
            }else{
              httpurl=this.url.edit;
              method = 'put';
            }

            let formData = Object.assign(this.model, values);

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok',res.result);
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(){
        this.form.setFieldsValue(pick(this.model,'coverImg','fileUrl','fileName','fileType'))
      },changeFileUrl(reUrl,fileName,fileType){
         if(reUrl.split(",").length>1){
           this.model.fileUrl = reUrl.split(",")[0];
           this.model.coverImg = reUrl.split(",")[1];
         }else{
           this.model.fileUrl = reUrl;
         }

        this.model.fileName = fileName;
        this.model.fileType = fileType;
        console.log(this.model);
        this.popupCallback();
      }
    }
  }
</script>
<style lang="less" scoped>

  /deep/ .ant-col-xs-24{
    float: inherit;
  }
  /deep/ .ant-form-item{
    margin-bottom: 0px !important;
  }

  .form-box{
    padding:24px;
  }
  .phrases-box{
    max-height: 400px;
    background:rgba(255, 255, 255, 1);
    color: rgba(56, 56, 56, 1);
    margin-top: -10px;
    padding-top: 10px;

  }
  .phrases-box div{
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    cursor: pointer;
  }
  /deep/ .ant-input-disabled.ant-input{
    background: rgb(244, 249, 253) !important;
  }
</style>